"use strict";
/** @module AccountApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
/**
 * Mixin class for account/join site lead API calls.
 */
var LeadMixin = /** @class */ (function () {
    function LeadMixin() {
    }
    /**
     * Get list of countries.
     * @param callback
     */
    LeadMixin.prototype.getCountries = function (callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.CountryInfo.parse, 'warn'));
        };
        this.http.get('/countries', null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Get list of country's regions.
     * @param code Country code.
     * @param callback
     */
    LeadMixin.prototype.getCountryRegions = function (code, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.RegionInfo.parse, 'warn'));
        };
        this.http.get("/countries/" + code + "/regions", null, this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create sign up for agency.
     * [Endpoint spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Actions/CreateSignUp.md)
     * @param agencyName
     * @param agencyTypes
     * @param country
     * @param region
     * @param products: ProductEnum (bryx911, bryxStation, bryxHospital)
     * @param callback
     */
    LeadMixin.prototype.createSignUp = function (agencyName, agencyTypes, country, region, zipcode, products, jobTitle, callback, message, clientInfo) {
        var _this = this;
        if (message === void 0) { message = null; }
        if (clientInfo === void 0) { clientInfo = null; }
        var body = {
            agencyName: agencyName,
            agencyTypes: agencyTypes,
            products: products,
            country: country.code,
        };
        if (region) {
            body.region = region.code;
        }
        if (jobTitle) {
            body.jobTitle = jobTitle;
        }
        if (message) {
            body.message = message;
        }
        if (clientInfo) {
            body.name = clientInfo.name;
            body.email = clientInfo.email;
            if (clientInfo.phone) {
                body.phone = clientInfo.phone;
            }
        }
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post('/signups', null, body, // Body
        this.unauthenticatedCallback(wrappedCallback));
    };
    /**
     * Create lead for agency.
     * [Endpoint spec](https://gitlab.bryx.com/bryx911/bryx911-spec/blob/master/Actions/CreateLead.md)
     * @param userId
     * @param agencyInfo
     * @param product: ProductEnum (bryx911, bryxStation, bryxHospital)
     * @param message
     * @param callback
     */
    LeadMixin.prototype.createLead = function (name, email, phoneNumber, agencyName, state, callback) {
        var _this = this;
        var body = {
            product: 'bryx911',
        };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post('/leads', null, body, // Body
        this.unauthenticatedCallback(wrappedCallback));
    };
    return LeadMixin;
}());
exports.default = LeadMixin;
//# sourceMappingURL=LeadMixin.js.map